/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { VerificationStatus } from "./VerificationStatus";

/**
 * Response model for starting our ID verification process.
 */
export interface StartVerificationResponse {
  verification_id: string;
  status: VerificationStatus;
}
